import { useAsync } from 'react-use';
import { useContract } from '@thirdweb-dev/react-core';
import { useConfig } from '@app/config';
import { algebraPositionManagerABI } from '../../../abis/v3';
import { Address } from '@thirdweb-dev/sdk';
import { MAX_UINT128 } from '@app/constants/common';
import { CurrencyAmount, Pool, unwrappedToken } from '@cryptoalgebra/kim-sdk';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { SmartContract } from '@thirdweb-dev/react';
import { ethers } from 'ethers';

async function fetcher(
  contract: SmartContract<ethers.BaseContract> | undefined,
  tokenId: number | undefined,
  asWETH: boolean,
  pool: Pool | undefined
) {
  if (!contract || !tokenId) {
    return;
  }

  const owner = await contract.call('ownerOf', [BigInt(tokenId)]);

  const amountsConfigTx = contract.prepare('collect', [
    {
      tokenId: BigInt(tokenId || 0),
      recipient: owner as Address,
      amount0Max: MAX_UINT128,
      amount1Max: MAX_UINT128
    }
  ]);

  const amounts = await amountsConfigTx.simulate();

  if (pool && amounts) {
    return {
      amount0: CurrencyAmount.fromRawAmount(
        !asWETH ? unwrappedToken(pool.token0) : pool.token0,
        amounts[0].toString()
      ),
      amount1: CurrencyAmount.fromRawAmount(
        !asWETH ? unwrappedToken(pool.token1) : pool.token1,
        amounts[1].toString()
      )
    };
  } else {
    return {
      amount0: undefined,
      amount1: undefined
    };
  }
}

export function usePositionFees(pool?: Pool, tokenId?: number, asWETH = false) {
  const config = useConfig();

  const { contract } = useContract(
    config?.ALGEBRA_ADDRESSES.ALGEBRA_POSITION_MANAGER,
    algebraPositionManagerABI
  );

  // const { value } = useAsync(async () => {
  //   if (!contract || !tokenId) {
  //     return;
  //   }
  //
  //   const owner = await contract.call('ownerOf', [BigInt(tokenId)]);
  //
  //   const amountsConfigTx = contract.prepare('collect', [
  //     {
  //       tokenId: BigInt(tokenId || 0),
  //       recipient: owner as Address,
  //       amount0Max: MAX_UINT128,
  //       amount1Max: MAX_UINT128
  //     }
  //   ]);
  //
  //   const amounts = await amountsConfigTx.simulate();
  //
  //   if (pool && amounts) {
  //     return {
  //       amount0: CurrencyAmount.fromRawAmount(
  //         !asWETH ? unwrappedToken(pool.token0) : pool.token0,
  //         amounts[0].toString()
  //       ),
  //       amount1: CurrencyAmount.fromRawAmount(
  //         !asWETH ? unwrappedToken(pool.token1) : pool.token1,
  //         amounts[1].toString()
  //       )
  //     };
  //   } else {
  //     return {
  //       amount0: undefined,
  //       amount1: undefined
  //     };
  //   }
  // }, [contract, tokenId, pool]);

  const { data: value } = useQuery(
    [
      QueryKeys.POSITION_FEES,
      tokenId,
      !!contract,
      pool?.token0.address,
      pool?.token1.address,
      asWETH
    ],
    () => fetcher(contract, tokenId, asWETH, pool),
    {
      enabled: Boolean(contract && tokenId)
    }
  );

  return {
    amount0: value?.amount0,
    amount1: value?.amount1
  };
}
